import React from 'react';
import { DowntimeIcon } from './DowntimeIcon';
import { useIsInIframe } from '../../hooks/use-is-in-iframe';

export function DowntimeModal({ title, message, actionButton }) {
  const isInIframe = useIsInIframe();

  return (
    <div className="as-Error-body">
      <h2 className="as-Error-title">{title}</h2>
      {!isInIframe && (
        <p
          className="as-Error-message"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      <div className="as-Error-icon">
        <DowntimeIcon />
      </div>
      {!isInIframe && actionButton.isVisible && (
        <a
          href={actionButton.href}
          className="as-Error-actionButton"
          target="_blank"
          rel="noopener noreferrer"
        >
          {actionButton.title}
        </a>
      )}
    </div>
  );
}
